// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DjHI","left":"styles_left__28eHU"};